import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ContentWrapper, ContentContainer, CloseButton } from '../style.css';
import Store from '../../../common/models/Store';
import { setNewsletterDisplayedSessionCookie } from '../../../helpers/cookie';
import { NewsletterSubscription } from '../../NewsletterSubscriptionHandler/NewsletterSubscriptionHandler';
import Lightbox from '../Lightbox';
import { Desktop, Mobile } from '../../MediaQuery';

/* Interfaces */
interface NewsletterLightboxProps {
  basePathWeb: string;
  close: () => void;
}

interface NewsletterLightboxContentProps {
  border?: string;
  close: () => void;
  contentBackground?: string;
  contentHeight?: string;
  contentWidth?: string;
  wrapperBackground?: string;
  wrapperHeight?: string;
  wrapperWidth?: string;
}

/* Helpers */
const mapStateToProps = ({ api: { basePathWeb } }: Store) => ({
  basePathWeb,
});

/* Components */
/* eslint-disable-next-line react/prefer-stateless-function */
const NewsletterLightboxContent: React.FC<NewsletterLightboxContentProps> = ({
  close,
  wrapperHeight,
  wrapperWidth,
  wrapperBackground,
  contentHeight,
  contentWidth,
  border,
}) => (
  <Lightbox close={close}>
    <ContentWrapper
      background={wrapperBackground}
      height={wrapperHeight}
      onClick={e => e.stopPropagation()}
      width={wrapperWidth}
    >
      <ContentContainer border={border} height={contentHeight} width={contentWidth}>
        <CloseButton onClick={close}>×</CloseButton>
        <NewsletterSubscription />
      </ContentContainer>
    </ContentWrapper>
  </Lightbox>
);

const NewsletterLightbox: React.FC<NewsletterLightboxProps> = ({ basePathWeb, close }) => {
  useEffect(() => {
    setNewsletterDisplayedSessionCookie(basePathWeb);
  }, [basePathWeb]);
  return (
    <>
      <Desktop>
        <NewsletterLightboxContent close={close} />
      </Desktop>
      <Mobile>
        <NewsletterLightboxContent
          close={close}
          contentHeight={'330px'}
          contentWidth={'320px'}
          wrapperHeight={'350px'}
          wrapperWidth={'340px'}
        />
      </Mobile>
    </>
  );
};

export default connect(mapStateToProps)(NewsletterLightbox);
